import React from "react";

import PropTypes from "prop-types";

import { ReactComponent as IconSearch24 } from "../../icons/icon/24/a-icon-search-24.svg";
import { ReactComponent as IconSearchPopular24 } from "../../icons/icon/24/a-icon-searchpopular-24.svg";
import LinkButton from "../button/linkButton";

const SearchTerm = ({
  children,
  onClick,
  popular = false,
}) => (
  <LinkButton variant="normal" onClick={onClick}>
    {popular
      ? <IconSearch24 className="mr-12 text-grey-medium" />
      : <IconSearchPopular24 className="mr-12 text-grey-medium" />}
    <div className="typo-label">{children}</div>
  </LinkButton>
);

SearchTerm.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  popular: PropTypes.bool,
};

export default SearchTerm;
